import IdForm from './../component/verification_forms/IdForm'
import BoardingPassForm from './../component/verification_forms/BoardingPassForm'
import ETicketForm from './../component/verification_forms/ETicketForm'
import BookingConfirmationForm from './../component/verification_forms/BookingConfirmationForm'
import FlightInvoiceForm from './../component/verification_forms/FlightInvoiceForm'
import BoardingPassEquivalentForm from './../component/verification_forms/BoardingPassEquivalentForm'
import AirlineCertificateForm from './../component/verification_forms/AirlineCertificateForm'
import Article8Form from './../component/verification_forms/Article8Form'
import Article9Form from './../component/verification_forms/Article9Form'
import Article12Form from './../component/verification_forms/Article12Form'
import WaiverForm from './../component/verification_forms/WaiverForm'
import LegalFormalNoticeForm from './../component/verification_forms/LegalFormalNoticeForm'

const documentTypes = [
  { text: 'ID / Passport', value: 'Documents::Id', color: 'red', formComponent: IdForm },
  { text: 'Airline Certificate', value: 'Documents::AirlineCertificate', color: 'green', formComponent: AirlineCertificateForm },
  { text: 'Boarding Pass', value: 'Documents::BoardingPass', color: 'teal', formComponent: BoardingPassForm },
  { text: 'Boarding Pass Equivalent', value: 'Documents::BoardingPassEquivalent', color: 'teal', formComponent: BoardingPassEquivalentForm },
  { text: 'Booking Confirmation', value: 'Documents::BookingConfirmation', color: 'yellow', formComponent: BookingConfirmationForm },
  { text: 'Rerouting', value: 'Documents::Rerouting', color: 'purple', formComponent: undefined },
  { text: 'Flight Invoice', value: 'Documents::FlightInvoice', color: 'olive', formComponent: FlightInvoiceForm },
  { text: 'E-Ticket', value: 'Documents::ETicket', color: 'violet', formComponent: ETicketForm },
  { text: 'Expenses art.8', value: 'Documents::TicketsRefund', color: 'brown', formComponent: Article8Form },
  { text: 'Expenses art.9', value: 'Documents::CostsRefund', color: 'pink', formComponent: Article9Form },
  { text: 'Expenses art.12', value: 'Documents::IndirectPrejudice', color: 'black', formComponent: Article12Form },
  { text: 'First letter', value: 'Documents::FirstLetter', color: 'blue', formComponent: undefined },
  { text: 'Waiver', value: 'Documents::Waiver', color: 'orange', formComponent: undefined },
  { text: 'Signed Waiver', value: 'Documents::SignedWaiver', color: 'orange', formComponent: WaiverForm },
  { text: 'Loa Lawyer', value: 'Documents::LoaLawyer', color: 'red', formComponent: undefined },
  { text: 'Legal Formal Notice', value: 'Documents::LegalFormalNotice', color: 'purple', formComponent: LegalFormalNoticeForm },
  { text: 'Formal Notice', value: 'Documents::AutomaticFormalNotice', color: 'yellow', formComponent: undefined },
  { text: 'Airline Payment Reminder', value: 'Documents::AirlinePaymentReminder', color: 'grey', formComponent: undefined },
  { text: 'Amicable Airline Answer', value: 'Documents::AmicableAirlineAnswer', color: 'grey', formComponent: undefined },
  { text: 'Case Law', value: 'Documents::CaseLaw', color: 'blue', formComponent: undefined },
  { text: 'Court Application', value: 'Documents::CourtApplication', color: 'black', formComponent: undefined },
  { text: 'External Loa', value: 'Documents::Loa', color: 'red', formComponent: undefined },
  { text: 'Subrogation', value: 'Documents::Subrogation', color: 'red', formComponent: undefined }
];


function findDocumentType(type) {
  const documentType = documentTypes.find((documentType) => {
    return documentType.value === type
  }) || {}
  return documentType
}

export { findDocumentType }

export default documentTypes;



// WEBPACK FOOTER //
// ./src/utils/documentTypes.js